export const disciplineAllegations = [
	{
		vb: 'Mapleview Developments Ltd.',
		link: '/profile/B46303',
		referralDate: 'November 10, 2023',
		nextSteps: 'Proceedings stayed due to Receivership Order dated March 21, 2024'
	},
	{
		vb: 'Starlish Home Corp.',
		link: '/profile/B46885',
		referralDate: 'October 31, 2024',
		nextSteps: 'To be confirmed'
	},
];

export const disciplineDecisions = [
	{
		vb: "Dormer Bond Inc.",
		link: "/profile/B47898",
		decisionDate: "June 19, 2026",
		decisionTxt: "Dormer Bond Inc. violated section 3 of the Code of Ethics by charging purchasers unjustified alternate materials fees and unsupported legal and administrative fees. It committed 90 violations of this section. Dormer Bond Inc. did not obstruct a purchaser from making a complaint to the Registrar.",
		outcomeTxt: "Sentencing to be determined at a later date.",
		documents: [
			{
				title: "Decision and Reasons",
				doc: "Decision and Reasons re HCRA and Dormer Bond Inc_Signed.pdf",
			},
		],
	},
	{
    vb: "Briarwood (Angus) Ltd., Briarwood Estates (Sutton) Ltd., 863195 Ontario Limited, 2401886 Ontario Limited",
    link: "",
    decisionDate: "September 17, 2025",
    decisionTxt:
      "The Discipline Committee granted Briarwood's non-suit motion and dismissed 128 counts in the statement of allegations.",
    outcomeTxt: "No findings were made against this licensee​​​​​​",
    documents: [
      {
        title:
          "Oral Ruling of the Panel-Non-Suit Motion Delivered on September 17, 2025",
        doc: "2025-09-17 HCRA v Briarwood - Oral Ruling re granting non-suit motion.pdf",
      },
      {
        title:
          "Oral Ruling of the Panel- Non-Suit Motion: Preliminary Issues Delivered on September 15, 2025",
        doc: "2025-09-15 HCRA v Briarwood - Oral Ruling re allowing non-suit motion to proceed.pdf",
      },
      {
        title:
          "Oral Ruling of the Panel- Motion re Expert Qualifications Delivered September 12, 2025 ",
        doc: "2025-09-12 HCRA v Briarwood - Oral ruling re motion to disqualify expert witness.pdf",
      },
    ],
  },
	{
		vb: '1332741 Ontario Inc.',
		link: '/profile/B28375',
		decisionDate: 'November 20, 2022',
		decisionTxt:
			'NHCLA - Code of Ethics - s. 2 Licencee to ensure compliance; s.9 Intimidation coercion etc.; and s. 16 Obstruction of complaints',
		outcomeTxt:
			'1332741 Ontario Inc. o/a Patten Homes 2000 is ordered to pay a fine of $10,000 and to arrange for its employees to complete the following education courses: Customer Service and Tarion Requirements, Legal Issues in Housing'
	},
	{
		vb: 'LJM Developments (Stoney Creek) Inc.',
		link: '/profile/B46112',
		decisionDate: 'October 17, 2024',
		decisionTxt:
			'LJM Developments (Stoney Creek) Inc. has failed to comply with Section 3 and 6 of the Code of Ethics, being Ontario regulation 245/21 made under the New Home Construction Licensing Act, 2017.',
		outcomeTxt:
			'LJM Developments (Stoney Creek) Inc. is ordered to pay a fine of $60,000 to the HCRA and arrange for Liaquat Mian and Muhammad Ahsan to complete and pass educational courses within 60 days of the date of the Order.'
	}
];
